import { render, staticRenderFns } from "./TipoCampanhaCards.vue?vue&type=template&id=48fa394f&scoped=true"
import script from "./TipoCampanhaCards.vue?vue&type=script&lang=js"
export * from "./TipoCampanhaCards.vue?vue&type=script&lang=js"
import style0 from "./TipoCampanhaCards.vue?vue&type=style&index=0&id=48fa394f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa394f",
  null
  
)

export default component.exports